module.exports = __webpack_public_path__ + "img/logo_prefeitura.aa8454fc.png";